import {FC, ReactNode} from 'react';
import style from './title.module.scss';
import clsx from 'clsx'

interface TitleProps {
  children: ReactNode;
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p';
  size?: 'lg' | 'md'
  className?: string;
}

export const Title: FC<TitleProps> = ({ as: Tag = 'h1', size = 'lg', children, className = '' }) => {
  return (
    <Tag
      className={clsx(
        {
          [style.title_lg]: size === 'lg',
          [style.title_md]: size === 'md',
        },
        className
      )}
    >
      {children}
    </Tag>
  )
};
